module.exports = __webpack_public_path__ + "static/media/za.cb074c40.svg";